import { BatteryIndicator as UiBatteryIndicator } from '@ixicare/ui';
import { ComponentProps } from 'react';
import { t } from '~/i18n';

const BatteryIndicator = (props: ComponentProps<typeof UiBatteryIndicator>) => (
  <UiBatteryIndicator
    levelLabels={{
      high: t('global.battery.high'),
      medium: t('global.battery.medium'),
      low: t('global.battery.low'),
    }}
    {...props}
  />
);

export default BatteryIndicator;
